export default {
    'footer': {
        'logOut': 'Log Out',
        'logIn': 'Log In',
        'tc': 'T & C',
        'share': 'Share',
        'language': 'Language',
        'policies': 'Policies',
        'press': 'Press',
        'error404': 'Error 404',
    }
}


// WEBPACK FOOTER //
// ./client/app/components/footer/i18n/en.js